import {BrowserRouter, Route, Routes} from "react-router-dom";
import Signature from "./pages/Signature";
import Success from "./pages/Success";
import Error from "./components/Error";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Error/>}/>
                <Route path="/signature" element={<Error/>}/>
                <Route path="/signature/:token" element={<Signature/>}/>
                <Route path="/success" element={<Success/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
